import { useState } from "react";

export const useFormCloseConfirm = (defaultFormData: any) => {
  const [formData, setFormData] = useState(defaultFormData);

  const setInitialFormData = (data: any) => {
    setFormData(structuredClone(data));
  };

  const canCloseForm = (updatedData: any) => {
    if (!isFormDirty(formData, updatedData)) {
      return true;
    }

    return window.confirm(`You have unsaved changes\r\nAre you sure you want to cancel?`);
  };

  // Function to check if form data has changed
  const isFormDirty = (initialData: any, updatedData: any) => {
    if (!initialData) return false;

    // Compare the current form data with the initial data
    return JSON.stringify(initialData) !== JSON.stringify(updatedData);
  };

  return { setInitialFormData, canCloseForm };
};
